module.exports = __webpack_public_path__ + "static/using-goals-b3a7b5bb4135f3e01df4cd6949d45110.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/using-goals.png
// module id = 2703
// module chunks = 157636680307020